export default __webpack_public_path__ + "media/zurb/img/work/iqtell-thumb-919f3e0158d2d59794d0968554d37421.png";